import { ActionType } from 'redux-promise-middleware';

export const fulfilled = (type: string) => `${type}_${ActionType.Fulfilled}`;
export const rejected = (type: string) => `${type}_${ActionType.Rejected}`;
export const pending = (type: string) => `${type}_${ActionType.Pending}`;
